export function setWebpackPublicPath(publicPath: string) {
  // eslint-disable-next-line no-undef
  __webpack_public_path__ = publicPath
}
